import { throwError, Observable } from 'rxjs';
import { isDevMode } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../environments/environment';
import * as _ from 'lodash';
import { BaseService } from './baseService';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class LogService extends BaseService {
  constructor(private apiService: ApiService) {
    super();
  }

  public logError(error: any, message: string = null) {
    if (isDevMode()) {
      if (message != null) {
        console.error(message);
      }
      console.error(error);
    }
    if (this.isConnection) this.apiService.post('/log/error', { href: document.location.href, error }).subscribe();
  }

  public logWarn(error: any, message: string = null) {
    if (isDevMode()) {
      if (message != null) {
        console.error(message);
      }
      console.warn(error);
    }
    if (this.isConnection && error) this.apiService.post('/log/error', { href: document.location.href, error }).subscribe();
  }
}
